import React from "react";

import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { useAppDispatch, useAppSelector } from "store";
import {
    PartnerFilterStep,
    hidePartnerFilters,
    selectActiveStep,
    selectCandidatePartner,
    selectCandidateOperator,
    setActiveStep
} from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";
import { choosePartner, chooseOperator, clearSelectedOperator } from "modules/customer/tools/product/productSlice";

const StyledButton = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(-1.5)
    }
}))(Button);

const Actions: React.FC = () => {
    const dispatch = useAppDispatch();
    const activeStep = useAppSelector(selectActiveStep);
    const candidatePartner = useAppSelector(selectCandidatePartner);
    const candidateOperator = useAppSelector(selectCandidateOperator);

    const handleBackClick = () => {
        let previousStep: PartnerFilterStep;
        switch (activeStep) {
            case PartnerFilterStep.SelectOperator:
                previousStep = PartnerFilterStep.SelectPartner;
                break;
            case PartnerFilterStep.SelectPartner:
            default:
                previousStep = PartnerFilterStep.SelectPartner;
                break;
        }
        dispatch(setActiveStep(previousStep));
    };

    const handleNextClick = () => {
        let nextStep: PartnerFilterStep;
        switch (activeStep) {
            case PartnerFilterStep.SelectPartner:
                nextStep = PartnerFilterStep.SelectOperator;
                break;
            case PartnerFilterStep.SelectOperator:
            default:
                nextStep = PartnerFilterStep.SelectOperator;
                break;
        }
        dispatch(setActiveStep(nextStep));
    };

    const handleFinishClick = () => {
        if (!candidatePartner) {
            return;
        }

        if (candidatePartner) {
            dispatch(choosePartner(candidatePartner));
        }

        if (candidateOperator) {
            dispatch(chooseOperator(candidateOperator));
        }
        else {
            dispatch(clearSelectedOperator());
        }
        
        dispatch(hidePartnerFilters());
    };

    return (
        <>
            <StyledButton
                variant="text"
                size="medium"
                color="default"
                disableElevation
                onClick={handleBackClick}
                disabled={activeStep === PartnerFilterStep.SelectPartner}
                data-cy="btn-back"
            >
                Back
            </StyledButton>
            {(activeStep === PartnerFilterStep.SelectPartner) && (
                <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    disableElevation
                    onClick={handleNextClick}
                    disabled={!candidatePartner}
                    data-cy="btn-next"
                >
                    Next
                </Button>
            )}
            {(activeStep === PartnerFilterStep.SelectOperator) && (
                <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    disableElevation
                    onClick={handleFinishClick}
                    data-cy="btn-finish"
                >
                    Finish
                </Button>
            )}
        </>
    );
};

export default Actions;
